import {
  EventEmitter,
  Component,
  OnInit,
  Output,
  Input,
  ViewChildren,
  QueryList,
} from "@angular/core";
import { ProductsMenu } from "src/app/core/entities/productMenu";
import { CatalogService } from "src/app/core/services/catalog.service";
import { CatalogMenuComponent } from "../catalog-menu/catalog-menu.component";

@Component({
  selector: "app-catalog-dynamic-dropdown",
  styleUrls: ["./catalog-dynamic-dropdown.component.css"],
  templateUrl: "./catalog-dynamic-dropdown.component.html",
})
export class CatalogDynamicDropdownComponent implements OnInit {
  @ViewChildren(CatalogMenuComponent)
  public submenu: QueryList<CatalogMenuComponent>;
  @Input()
  public filtersIn: any[];
  @Output() breadCrumb = new EventEmitter<string>();
  @Output()
  public sendFilters = new EventEmitter<number[]>();
  public filters: Set<number> = new Set();
  public rootFilters: Set<number> = new Set();
  public menu: ProductsMenu[];
  public loading: boolean = true;
  public lastSearch: string;
  public breadCrumb1: string;

  constructor(private catalogService: CatalogService) {
    this.lastSearch = "";
  }

  ngOnInit() {
    this.catalogService.getMenu().subscribe((menu) => (this.menu = menu));
  }

  public selectRoot(id: number, desc) {
    this.breadCrumb.emit(desc);
    // localStorage.setItem("selectedItem", JSON.stringify([{parent: desc}]))
    this.filters = new Set();
    this.submenu.forEach((c) => this.clear(c));
    this.sendFilters.emit([id]);
  }

  private clear(item: CatalogMenuComponent) {
    item.selected = false;
    item.submenu.forEach((i) => this.clear(i));
  }

  public onSelect(data) {
    data.forEach((item) => {
      this.filters.add(item.id);
    });
    this.sendFilters.emit(Array.from(this.filters));
  }

  public addObjectWithoutDuplicates(newItem, array) {
    const isDuplicate = array.some(
      (item) => item.name === newItem.name || item.id === newItem.id
    );
    if (!isDuplicate) {
      return true;
    } else {
      return false;
    }
  }

  public setLocalStorage(it, desc) {
    let arr = [];
    // let flag = false
    arr = it.map((i) => ({ name: i.description, id: i.id }));

    // if (localStorage.getItem("selectedItem")) {
    //   let items = JSON.parse(localStorage.getItem("selectedItem"))
    //   for (let i = 0; i < items.length; i++) {
    //     if (items[i].parent === desc) {
    //       console.log(items[i])
    //       items[i].items.push(...arr);
    //       flag = true
    //     }
    //   }
    //   localStorage.setItem("selectedItem", JSON.stringify(items))
    //   if (!flag) {
    //     localStorage.setItem("selectedItem", JSON.stringify([...items, { parent: desc, items: arr }]))
    //   }
    // } else {
    // localStorage.setItem("selectedItem", JSON.stringify([{ parent: desc, items: arr }]))
    // }
  }

  public onClick(desc, data) {
    this.setLocalStorage(data, desc);
    data.forEach((item) => {
      this.filters.add(item.id);
    });
    this.breadCrumb.emit(desc);
    this.sendFilters.emit(Array.from(this.filters));
  }
  saveBc(b) {
    this.breadCrumb1 = b;
    // localStorage.setItem("selectedItem", b)
    this.breadCrumb.emit(b);
  }
  selectAll(desc, item) {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox: any) => {
      if (
        checkbox.checked &&
        checkbox.className === localStorage.getItem("lastWord") + "-check"
      ) {
        checkbox.dispatchEvent(new Event("change"));
      }
    });

    var botao: any = document.getElementsByClassName(desc + "-check");
    var eventoMudanca = new Event("change", {
      bubbles: true,
      cancelable: true,
    });
    // if(localStorage.getItem("lastWord")){
    //   var input: any = document.getElementsByClassName(localStorage.getItem("lastWord")+'-check');
    //   for(let i= 0; i < input.length; i++){
    //     if(input[i].className === localStorage.getItem("lastWord")+'-check'){
    //       input[i].dispatchEvent(eventoMudanca)
    //     }
    //   }
    // }

    // for(let i =0; i < document.getElementsByTagName("input").length;i++){
    //   if(document.getElementsByTagName("input")[i].type === "checkbox"){
    //     document.getElementsByTagName("input")[i].checked = false
    //   }
    // }
    // console.log(desc+'-check')

    localStorage.setItem("lastWord", desc);
    for (let i = 0; i < botao.length; i++) {
      if (botao[i].className === desc + "-check") {
        botao[i].dispatchEvent(eventoMudanca);
      }
    }
  }
}
